import classes from "./OtpScreen.module.scss";
import React, { useEffect } from "react";
import { useFormik } from "formik";
import { signUpSchema } from "../../Schemas/Schemas";

import Input from "@mui/joy/Input";
import { Link, useNavigate } from "react-router-dom";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useState } from "react";
import Logo from "../../assets/Images/firstockLogo.svg";
import icon1 from "../../assets/Images/icon1.svg";
import icon2 from "../../assets/Images/icon2.svg";
import icon3 from "../../assets/Images/icon3.svg";
import icon4 from "../../assets/Images/icon4.svg";
import ellipse from "../../assets/Images/Ellipse.svg";

import { useDispatch, useSelector } from "react-redux";
import { setOtpFlag } from "../../Store/Project/ProjectSlice";
import { Button } from "@mui/material";
import {
  introducerLoginOTPValidationAPICall,
  introducerResendOTPAPICall,
} from "../../Utils/APICalls";
import { IIntroducerLogin, IIntroducerLoginOTP } from "../../Utils/dtos";
import ErrorSnackBar from "../../components/SnackBar/ErrorSnackBar";
import SucessSnackBar from "../../components/SnackBar/SuccessSnackBar";

const OtpScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [hoverEffect, setHoverEffect] = useState(true);
  const [otpLoading, setOtpLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const hoverData = [
    {
      title: "Lucrative Commissions",
      icon: icon1,
    },
    {
      title: "Dedicated Support",
      icon: icon2,
    },
    {
      title: "Diverse Opportunities",
      icon: icon3,
    },
    {
      title: "Interactive dashboard",
      icon: icon4,
    },
  ];
  const otpFlag = useSelector((state: any) => state.project.otpFlag);
  const initialValues = {
    email: "",
  };
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: signUpSchema,
      onSubmit: (values, action) => {
        //  console.log("values", values);
        // action.resetForm();
      },
    });
  const [otp, setOtp] = useState("");
  const [loading, setloading] = useState(false);
  const handleOtp = (newValue: any) => {
    setOtp(newValue);
  };

  const introducerDetails: any = sessionStorage.getItem("introducerDetails");
  const handleVerify = () => {
    let obj: IIntroducerLoginOTP = {
      introducer_details: introducerDetails,
      introducer_otp: otp,
    };

    introducerLoginOTPValidationAPICall(obj)
      .then((response: any) => {
        sessionStorage.setItem("access-token", response.data.data.access_token);
        sessionStorage.setItem(
          "userDetails",
          JSON.stringify(response.data.data.data)
        );
        // console.log("response", response.data.data.access_token)

        navigate("/dashboard");
      })
      .catch((error: any) => {
        if (error && error.response.data.error.message) {
          setErrorMessage(error.response.data.error.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };
  useEffect(() => {
    if (otp.length === 6) {
      handleVerify();
    }
  }, [otp]);
  const handleKeyPress = (event: any) => {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  };
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % hoverData.length);
      setHoverEffect(true);

      setTimeout(() => {
        setHoverEffect(false);
      }, 1000); // Reset hover effect after 1 second
    }, 2000); // Change every 2 seconds

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleResendOTP = () => {
    let obj: IIntroducerLogin = {
      introducer_details: introducerDetails,
    };
    setOtpLoading(true);
    introducerResendOTPAPICall(obj)
      .then((response: any) => {
        setOtpLoading(false);
        setSuccessMessage("Otp sent Successfully");
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);
      })
      .catch((error: any) => {
        setOtpLoading(false);
        if (error && error.response.data.error.message) {
          setErrorMessage(error.response.data.error.message);
          setTimeout(() => {
            setErrorMessage("");
          }, 5000);
        }
      });
  };

  return (
    <>
      <div className={classes.container}>
        <div className={classes.modal}>
          <div className={classes.modalContainer}>
            <div className={classes.modalLeft}>
              <div className={classes.companyLogo}>
                {/* <img src={Logo} className={classes.Logo} /> */}
                <p className={classes.Logo}>FIRSTOCK</p>
              </div>
              <div className={classes.CompanyTitleSection}>
                <p className={classes.CompanyTitle}>Welcome to Firstock</p>
                {/* <p className={classes.CompanyDesc}>
                  Select the suitable method to access your Firstock account.
                </p> */}
              </div>
              <div className={classes.otpSectionNew}>
                <p className={classes.otpSectionenterOtp}>Enter OTP</p>

                <p className={classes.otpSectionsentTo}>
                  OTP Sent to{" "}
                  <span style={{ fontWeight: 600 }}>{introducerDetails}</span>{" "}
                  <span
                    style={{
                      color: "rgba(0, 103, 121, 1)",
                      textDecoration: "underline",
                      cursor: "pointer",
                      marginLeft: "10px",
                    }}
                    onClick={() => {
                      window.location.href = "/";
                    }}
                  >
                    Edit
                  </span>
                </p>
              </div>

              <div className={classes.loginData}>
                <form onSubmit={handleSubmit}>
                  <div className={classes.inputBlock}>
                    <MuiOtpInput
                      length={6}
                      value={otp}
                      onChange={handleOtp}
                      onKeyPress={handleKeyPress}
                      className={classes.inputfeild}
                      sx={{
                        ".MuiOutlinedInput-notchedOutline": {
                          borderRadius: "2px",
                          border: "2px solid #006779",
                          // width:'40px',
                          // padding:'10px 2px !important'
                          // borderBottom: "3px solid rgba(0, 103, 121, 1)",
                        },
                        ".MuiOutlinedInput-input": {
                          padding: "0px !important",
                          height: "60px",
                        },
                      }}
                    />
                  </div>
                  <p className={classes.resendOTPSection}>
                    Didn't receive OTP?{" "}
                    {otpLoading ? (
                      <span
                        // onClick={handleResendOTP}
                        style={{
                          color: "grey",
                          // cursor: "pointer",
                        }}
                      >
                        Sending OTP...
                      </span>
                    ) : (
                      <span
                        onClick={handleResendOTP}
                        style={{
                          color: "rgba(0, 103, 121, 1)",
                          cursor: "pointer",
                        }}
                      >
                        Resend
                      </span>
                    )}
                  </p>
                  <div className={classes.modalButtons}>
                    <Button
                      style={{ padding: "10px 50px" }}
                      variant="contained"
                      sx={{
                        background: "rgba(0, 103, 121, 1)",
                        color: "white",
                        borderRadius: "10px",
                        textTransform: "none",
                        "&:hover": {
                          background: "rgba(0, 103, 121, 1)",
                          color: "white",
                        },
                      }}
                      onClick={handleVerify}
                      disabled={otp.length < 6}
                      // variant="outlined"
                    >
                      Submit
                    </Button>

                    <a href="#" className={classes.link}>
                      <Link
                        to={"/"}
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        Back to Login
                      </Link>
                    </a>
                  </div>
                  <ErrorSnackBar message={errorMessage} />
                  <SucessSnackBar message={successMessage} />
                </form>
              </div>
            </div>

            {/* <div className={classes.modalRight}>
              <div className={classes.modalRightHeader}>
                <p className={classes.modalRightHeaderTitle}>
                  Our <span style={{ fontWeight: 600 }}>Features</span>{" "}
                  Specially For you
                </p>
              </div>
              {hoverData.map((a: any, index: any) => (
                <div
                  className={classes.modalRightHoverSection}
                  style={{
                    background:
                      index === currentIndex && hoverEffect
                        ? "linear-gradient(to right,rgba(0, 103, 121, 1),rgba(217, 217, 217, 0) ) left"
                        : "",
                    transform:
                      index === currentIndex && hoverEffect
                        ? "translateX(10%)"
                        : "",
                  }}
                >
                  <div className={classes.modalRightHoverImageSection}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={ellipse}
                        style={{
                          width: "60%",
                          position: "absolute",
                          left: "-6px",
                        }}
                      />
                      <img
                        src={a.icon}
                        style={{
                          width: index === 0 ? "30px" : "22px",
                          position: "absolute",
                          left: index === 0 ? "17px" : "20px",
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <p className={classes.modalRightHoverText}>{a.title}</p>
                  </div>
                </div>
              ))}
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpScreen;
